import React from "react";
import PropTypes from "prop-types";
import useCatalogProductSlots from "../../core/use-catalog-product-slots.jsx";
import styles from "./HorizontalProductLayout.module.css";

export default function HorizontalProductLayout(props) {
  const { productIndex, isMobile } = props;

  const {
    imageBlock,
    metaBlock,
    controlsBlock,
    descriptionBlock,
    cardShellStyle,
    imageColStyle,
    isAiUpsellProfile,
  } = useCatalogProductSlots({
    ...props,
    isHorizontal: true,
  });

  return (
    <article
      className={`${styles.root} ${isAiUpsellProfile ? styles.aiUpsell : ""}`.trim()}
      style={cardShellStyle}
      data-product-index={productIndex}
      data-shell-layout="horizontal-v1"
    >
      <div className={styles.mainRow}>
        <div className={styles.imageCol} style={imageColStyle}>
          {imageBlock}
        </div>
        <div className={styles.metaCol}>
          {metaBlock}
          {controlsBlock}
        </div>
      </div>
      {descriptionBlock}
    </article>
  );
}

HorizontalProductLayout.propTypes = {
  section: PropTypes.object,
  productData: PropTypes.object,
  productIndex: PropTypes.number,
  popupData: PropTypes.object,
  isMobile: PropTypes.bool,
  layoutProfile: PropTypes.string,
};
